/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import '../common/tenant';
import './workflow_version';
import './funding_strategy';
import '../admin/accountvalidation/common';
import './check_deposit_workflow_state';
import './deposit_adjustment_reason';
import './decline_reason';
import './return_reason';
import '../common/review';
import '../risk/risk_decision';
import '../common/deposit_account';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "CheckDeposit": {
                            "fields": {
                              "token": {
                                "type": "string",
                                "id": 1
                              },
                              "finplatToken": {
                                "type": "string",
                                "id": 2
                              },
                              "idempotenceToken": {
                                "type": "string",
                                "id": 3
                              },
                              "ensentaReceiptNumber": {
                                "type": "string",
                                "id": 22
                              },
                              "tenant": {
                                "type": ".squareup.cash.gambit.api.v1.common.Tenant",
                                "id": 4
                              },
                              "amountInCents": {
                                "type": "int64",
                                "id": 5
                              },
                              "ensentaOcrAmountInCentsUsd": {
                                "type": "int64",
                                "id": 31
                              },
                              "originalAmountInCentsUsd": {
                                "type": "int64",
                                "id": 30
                              },
                              "lossInCentsUsd": {
                                "type": "int64",
                                "id": 29
                              },
                              "lastPartialAmountFunded": {
                                "type": "int64",
                                "id": 38
                              },
                              "cumulativeFundedAmountInCents": {
                                "type": "int64",
                                "id": 39
                              },
                              "workflowVersion": {
                                "type": ".squareup.cash.gambit.api.v1.checkdeposit.WorkflowVersion",
                                "id": 40
                              },
                              "fundingStrategy": {
                                "type": ".squareup.cash.gambit.api.v1.checkdeposit.FundingStrategy",
                                "id": 41
                              },
                              "submissionTimeMillis": {
                                "type": "int64",
                                "id": 21
                              },
                              "fundsHoldReleaseAtTimeMillis": {
                                "type": "int64",
                                "id": 27
                              },
                              "fundsHoldPeriodInBusinessDays": {
                                "type": "int32",
                                "id": 33
                              },
                              "checkImageFrontTrunkToken": {
                                "type": "string",
                                "id": 6
                              },
                              "checkImageBackTrunkToken": {
                                "type": "string",
                                "id": 7
                              },
                              "processedCheckImageFrontTrunkToken": {
                                "type": "string",
                                "id": 18
                              },
                              "processedCheckImageBackTrunkToken": {
                                "type": "string",
                                "id": 19
                              },
                              "accountOwnershipEwsDecision": {
                                "type": ".squareup.cash.gambit.api.v1.admin.accountvalidation.AccountValidationDecision",
                                "id": 8
                              },
                              "accountStatusEwsDecision": {
                                "type": ".squareup.cash.gambit.api.v1.admin.accountvalidation.AccountValidationDecision",
                                "id": 9
                              },
                              "lastCompletedWorkflowState": {
                                "type": ".squareup.cash.gambit.api.v1.checkdeposit.CheckDepositWorkflowState",
                                "id": 10
                              },
                              "lastDepositAdjustmentReason": {
                                "type": ".squareup.cash.gambit.api.v1.checkdeposit.DepositAdjustmentReason",
                                "id": 34
                              },
                              "customerToken": {
                                "type": "string",
                                "id": 11
                              },
                              "browserInteractionToken": {
                                "type": "string",
                                "id": 12
                              },
                              "squareUnitToken": {
                                "type": "string",
                                "id": 32
                              },
                              "declineReason": {
                                "type": ".squareup.cash.gambit.api.v1.checkdeposit.DeclineReason",
                                "id": 14
                              },
                              "returnReason": {
                                "type": ".squareup.cash.gambit.api.v1.checkdeposit.ReturnReason",
                                "id": 28
                              },
                              "manualReviewDecision": {
                                "type": ".squareup.cash.gambit.api.v1.common.Review.Result",
                                "id": 13
                              },
                              "manualReviewAssigneeLdap": {
                                "type": "string",
                                "id": 23
                              },
                              "automatedRiskReviewDecision": {
                                "type": ".squareup.cash.gambit.api.v1.risk.CheckDepositRiskDecision",
                                "id": 15
                              },
                              "ensentaErrorId": {
                                "type": "string",
                                "id": 16
                              },
                              "ensentaErrorLocalizedString": {
                                "type": "string",
                                "id": 17
                              },
                              "bankAccountFideliusToken": {
                                "type": "string",
                                "id": 20
                              },
                              "micrFideliusToken": {
                                "type": "string",
                                "id": 24
                              },
                              "checkNumber": {
                                "type": "string",
                                "id": 25
                              },
                              "experimentTag": {
                                "type": "string",
                                "id": 37
                              },
                              "transactionToken": {
                                "type": "string",
                                "id": 26
                              },
                              "payorBankName": {
                                "type": "string",
                                "id": 35
                              },
                              "depositAccount": {
                                "type": ".squareup.cash.gambit.api.v1.common.DepositAccount",
                                "id": 36
                              },
                              "sibylToken": {
                                "type": "string",
                                "id": 42
                              },
                              "wasVoidedAfterWorkflowCompletion": {
                                "type": "bool",
                                "id": 43
                              },
                              "previousDepositExecutionToken": {
                                "type": "string",
                                "id": 44
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.CheckDeposit) {
  $root.addJSON(jsonData);
}

/**
 * next id: 45
 *
 * SOURCE CheckDeposit @ squareup/cash/gambit/api/v1/checkdeposit/check_deposit.proto at 20:1
 */
export const CheckDeposit = $root.lookupType('squareup.cash.gambit.api.v1.checkdeposit.CheckDeposit');
fixType(CheckDeposit);
Builder.createAndAttachToType(CheckDeposit);